import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=83f5c35c&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83f5c35c')) {
      api.createRecord('83f5c35c', component.options)
    } else {
      api.reload('83f5c35c', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=83f5c35c&", function () {
      api.rerender('83f5c35c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/asserts/lib/vue-tabs/components/Tabs.vue"
export default component.exports